module.exports = __webpack_public_path__ + "img/majblomma.eebcd7a5.png";